<template lang='pug'>
  v-snackbar(v-model='show' left top) {{ mess }}
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    show: false,
    mess: null
  }),

  computed: mapState('app', ['snack']),
  methods: mapMutations('app', ['showSnack']),

  watch: {
    snack(mess) {
      if (!mess) return

      this.show = true
      this.mess = mess

      this.showSnack(null)
    }
  }
}
</script>
